import styled from "@emotion/styled";
import classNames from "classnames";
import React from "react";
import { getSize } from "utils/functions";

const StyledRow = styled.div`
  height: ${({ height }) => getSize(height)};
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  align-items: center;
  padding: 0 10px;
  min-width: max-content;
  width: 100%;
  border-radius: 10px;
  margin-bottom: 10px;

  &.head {
    background-color: transparent;
    height: max-content;
  }

  @media only screen and (max-width: 1536px) {
    height: ${({ height }) => getSize(height * 0.8)};
  }
`;

const TableRow = ({ head, height = 70, backgroundColor = "#0D8CEB1A", className = "", style = {}, children }) => {
  return (
    <StyledRow {...{ head, backgroundColor, height, style }} className={classNames("row", { [className]: !!className, head })}>
      {children}
    </StyledRow>
  );
};

export default TableRow;
